import { render, staticRenderFns } from "./BoxSectionActions.vue?vue&type=template&id=0b8b2b0f&scoped=true&"
import script from "./BoxSectionActions.vue?vue&type=script&lang=js&"
export * from "./BoxSectionActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b2b0f",
  null
  
)

export default component.exports